var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.286.714v1.429c0 .394-.32.714-.715.714H10.77L7.198 17.143h2.088c.394 0 .714.32.714.714v1.429c0 .394-.32.714-.714.714H.714C.32 20 0 19.68 0 19.286v-1.429c0-.394.32-.714.714-.714h2.802L7.088 2.857H5c-.394 0-.714-.32-.714-.714V.714C4.286.32 4.606 0 5 0h8.571c.395 0 .715.32.715.714z",
    transform: "translate(5 2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/italic.26439c1936456f6f83c05361d5e66764.svg";
export { ForwardRef as ReactComponent };